/**
 * @Author: wangzhuang@baidu.com
 * @Date: 2023-01-10 17:48:54
 * @LastEditors: v_huangyongxing@baidu.com
 * @LastEditTime: 2023-08-23 17:12:55
 * @FilePath: /m-anquan-baidu-com/src/containers/appliSucc/index.js
 * @Description: 申请试用成功
 */

import React, {Component} from 'react';

import './index.less';

export default class ApplySucc extends Component {
    constructor(props, context) {
        super(props, context);
    }

    componentWillMount() {
        if (this.isPC()) {
            location.href = '/';
        }
    }

    closeFun = () => {
        window.close();
    };

    render() {
        return (
            <div className={'apply-succ'}>
                <h3>提交成功</h3>
                <div className={'apply-succ-des'}>
                    您的申请已提交，之后会有我们的商务团队与您联系，谢谢！
                </div>
                <div className={'apply-succ-img'}>
                    <img src={require('../../asset/svg/apply-succ.svg')} alt="" />
                </div>
                {
                    location.href.includes('isLlmsec=true') ? <a className={'apply-succ-btn'}
                        href={
                            'https://bj.bcebos.com/ensec-web-privacy/anquan/大模型安全解决方案白皮书.pdf'
                        }
                        target="_blank">下载白皮书</a> : null
                }

                <div className={'window-close'} onClick={this.closeFun}>
                    关闭
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/appliSucc/index.js